import { render, staticRenderFns } from "./InputFormTel.vue?vue&type=template&id=8175a9e2&"
import script from "./InputFormTel.vue?vue&type=script&lang=ts&"
export * from "./InputFormTel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports